import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, Output } from '@angular/core'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { DdcLoggerService } from 'src/app/service/log/ddc-logger.service'

@Component({
  selector: 'ddc-button-follow',
  templateUrl: './ddc-button-follow.component.html',
  styleUrl: './ddc-button-follow.component.scss',
  imports: [CommonModule, AngularMaterialsModules],
})
export class DdcButtonFollowComponent {
  @Input() _isFollowing: boolean = false
  @Output() followToggle = new EventEmitter<boolean>()

  constructor(private logger: DdcLoggerService) {}

  get buttonColor(): string {
    return this._isFollowing ? 'warn' : 'primary'
  }

  get buttonText(): string {
    return this._isFollowing ? 'Unfollow' : 'Follow'
  }

  toggleFollow(): void {
    this._isFollowing = !this._isFollowing
    this.followToggle.emit(this._isFollowing)
  }
}
